// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./libs/kendoUI/style/kendo.material.min.css
// module id = 790
// module chunks = 40